'use es6';

import * as TierGroups from 'marketplace-ui-common/constants/groupTags/TierGroups';
let _flattenedTierOrder;
const getFlattenedTierOrder = isUngatedForContentHub => {
  if (!_flattenedTierOrder) {
    _flattenedTierOrder = [TierGroups.CRM, TierGroups.MARKETING, TierGroups.SALES, TierGroups.SERVICE, isUngatedForContentHub ? TierGroups.CONTENT : TierGroups.CMS, TierGroups.OPERATIONS].reduce((acc, val) => acc.concat(val), []);
  }
  return _flattenedTierOrder;
};
export const getMinimumRequiredPlan = (integrationFeature, compatibility, portalTiers, isUngatedForContentHub) => {
  if (!integrationFeature.get('hubSpotFeatures')) {
    return '';
  }
  const flattenedTierOrder = getFlattenedTierOrder(isUngatedForContentHub);
  return integrationFeature.get('hubSpotFeatures').reduce((minimumRequiredPlan, feature) => {
    const requiredTiers = compatibility.get(feature).filter(tier => flattenedTierOrder.includes(tier));
    if (!requiredTiers.size || !portalTiers.intersect(requiredTiers).isEmpty()) {
      // Current plan compatible with this feature
      return minimumRequiredPlan;
    }
    // Current plan incompatible, find lowest compatible plan
    return [...requiredTiers, ...(minimumRequiredPlan ? [minimumRequiredPlan] : [])].sort((tierA, tierB) => flattenedTierOrder.indexOf(tierA) - flattenedTierOrder.indexOf(tierB))[0];
  }, '');
};